import LifestyleAndAdviceSection from ".";

export default function LifestyleAndAdviceSectionExamples() {
  return <LifestyleAndAdviceSection />;
}
